import { render, staticRenderFns } from "./wording-scan-barcode.vue?vue&type=template&id=0079bc2b&"
import script from "./wording-scan-barcode.vue?vue&type=script&lang=js&"
export * from "./wording-scan-barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports